export var ErrorMessageTexts;
(function (ErrorMessageTexts) {
    ErrorMessageTexts["undefined"] = "common_unexpected_error";
    ErrorMessageTexts["DEFAULT"] = "common_unexpected_error";
    // CORRECT
    ErrorMessageTexts["USER_OR_PASSWORD_INCORRECT"] = "login_error_incorrect_creds";
    ErrorMessageTexts["USER_NOT_FOUND"] = "error_user_not_found";
    // INCORRECT: change and add the value to the translation file
    ErrorMessageTexts["EMAIL_NOT_VERIFIED"] = "error_email_not_verified";
    ErrorMessageTexts["EMAIL_ALREADY_IN_USE"] = "error_email_in_use";
    ErrorMessageTexts["INVALID_EMAIL"] = "validation_email";
    ErrorMessageTexts["USER_HAS_BEEN_SUSPENDED"] = "error_suspended_user";
    ErrorMessageTexts["VAULT_ACCOUNT_NOT_FOUND"] = "error_vault_acc_not_found";
    ErrorMessageTexts["CURRENCY_NOT_FOUND"] = "error_currency_not_found";
    ErrorMessageTexts["CURRENCY_DISABLED"] = "error_currency_disabled";
    ErrorMessageTexts["NOT_ENOUGH_BALANCE"] = "error_not_enough_balance";
    ErrorMessageTexts["ASSET_NOT_FOUND"] = "error_asset_not_found";
    ErrorMessageTexts["CRYPTO_TRANSACTION_NOT_FOUND"] = "error_crypto_transaction_not_found";
    ErrorMessageTexts["NOT_VALID_REFERRER_CODE"] = "error_invalid_referrer_code";
    ErrorMessageTexts["ADDRESS_NOT_FOUND"] = "error_address_not_found";
    ErrorMessageTexts["TRANSACTION_NOT_CREATED_BUT_UPDATED"] = "error_transaction_not_created_but_updated";
    ErrorMessageTexts["TRANSACTION_ALREADY_CREATED"] = "error_transaction_already_created";
    ErrorMessageTexts["UNSUPPORTED_ASSET"] = "error_unsupported_asset";
    ErrorMessageTexts["BANK_REQUISITE_REQUIRED"] = "error_bank_requisite_required";
    ErrorMessageTexts["INVALID_FILE_FORMAT"] = "error_invalid_file_format";
    ErrorMessageTexts["FILE_SIZE_MORE_THAN_ALLOWED"] = "error_file_size_more_than_allowed";
    ErrorMessageTexts["UNSUPPORTED_CRYPTO"] = "error_unsupported_crypto";
    ErrorMessageTexts["ASSET_ALREADY_EXISTS"] = "error_asset_already_exists";
    ErrorMessageTexts["SMS_TWO_FACTOR_NOT_VERIFIED"] = "error_sms_two_factor_not_verified";
    ErrorMessageTexts["TWO_FACTOR_NOT_VERIFIED"] = "error_two_factor_not_verified";
    ErrorMessageTexts["TWO_FA_DISABILITY_NOT_ALLOWED"] = "error_two_fa_disability_not_allowed";
    ErrorMessageTexts["PAYMENT_NOT_FOUND"] = "error_payment_not_found";
    ErrorMessageTexts["BOG_TOKEN_COULD_NOT_GENERATED"] = "error_bog_token_not_generated";
    ErrorMessageTexts["CARD_NOT_FOUND"] = "error_card_not_found";
    ErrorMessageTexts["UNSUPPORTED_PAYMENT_METHOD"] = "error_unsupported_payment_method";
    ErrorMessageTexts["BALANCE_NOT_OPENED"] = "error_balance_not_opened";
    ErrorMessageTexts["UNSUPPORTED_TRADE_ACTION"] = "error_unsupported_trade_action";
    ErrorMessageTexts["UNSUPPORTED_ORDER_CRYPTO_DTO"] = "error_unsupported_order_crypto_dto";
    ErrorMessageTexts["ASSET_NOT_OPENED"] = "error_asset_not_opened";
    ErrorMessageTexts["WITHDRAW_BANK_WIRE_ACTION_DISABLED"] = "error_withdraw_bank_wire_disabled";
    ErrorMessageTexts["DEPOSIT_BANK_WIRE_ACTION_DISABLED"] = "error_deposit_bank_wire_disabled";
    ErrorMessageTexts["WITHDRAW_CRYPTO_ACTION_DISABLED"] = "error_withdraw_crypto_action_disabled";
    ErrorMessageTexts["INVALID_DESTINATION_BANK"] = "error_withdraw_invalid_destination_bank";
    ErrorMessageTexts["PASSWORDS_DO_NOT_MATCH"] = "error_passwords_dont_match";
    ErrorMessageTexts["INVALID_TOKEN"] = "error_invalid_token";
    ErrorMessageTexts["REFERRER_CODE_REQUIRED"] = "error_referrer_code_required";
    ErrorMessageTexts["USER_ALREADY_EXIST"] = "error_user_already_exists";
    ErrorMessageTexts["REFERRER_CODE_DOES_NOT_EXIST"] = "error_referrer_code_does_not_exist";
    ErrorMessageTexts["WRONG_VERIFICATION_TOKEN"] = "error_wrong_verification_token";
    ErrorMessageTexts["PASSWORD_INCORRECT"] = "error_incorrect_password";
    ErrorMessageTexts["INVALID_CREDENTIALS"] = "error_invalid_credentials";
    ErrorMessageTexts["NEW_MAIL_MUST_BE_DIFFERENT_FROM_OLD_ONE"] = "error_new_mail_must_be_different";
    ErrorMessageTexts["INCORRECT_CODE"] = "error_incorrect_code";
    ErrorMessageTexts["NEW_PHONE_MUST_BE_DIFFERENT_FROM_OLD_ONE"] = "error_new_phone_must_be_different";
    ErrorMessageTexts["USER_ALREADY_VERIFIED"] = "error_user_already_verified";
    ErrorMessageTexts["WRONG_AUTHENTICATION_CODE"] = "error_wrong_authentication_code";
    ErrorMessageTexts["PHONE_ALREADY_EXISTS"] = "error_phone_already_exists";
    ErrorMessageTexts["PHONE_NOT_FOUND"] = "error_phone_not_found";
    ErrorMessageTexts["EMAIL_OR_PHONE_REQUIRED"] = "error_email_or_phone_required";
    ErrorMessageTexts["TWO_FACTOR_NOT_FOUND"] = "error_two_factor_not_found";
    ErrorMessageTexts["BALANCE_NOT_FOUND"] = "error_balance_not_found";
    ErrorMessageTexts["TRADE_NOT_FOUND"] = "error_trade_not_found";
    ErrorMessageTexts["SOURCE_ADDRESS_NOT_FOUND"] = "error_source_address_not_found";
    ErrorMessageTexts["WITHDRAWAL_EMAIL_DATA_MISSING"] = "error_withdrawal_email_data_missing";
    ErrorMessageTexts["DESTINATION_ADDRESS_SHOULD_BE_DIFFERENT"] = "error_destination_address_must_be_different";
    ErrorMessageTexts["EXCHANGE_LIMIT_EXCEEDED"] = "error_exchange_limit_exceeded";
    ErrorMessageTexts["WITHDRAWAL_LIMIT_EXCEEDED"] = "error_withdrawal_limit_exceeded";
    ErrorMessageTexts["INVALID_ORIGINAL_AMOUNT"] = "error_minimum_exchange";
    ErrorMessageTexts["NOT_ENOUGH_VOLUME"] = "error_not_enough_volume";
    ErrorMessageTexts["NOT_ENOUGH_COST"] = "error_not_enough_cost";
    ErrorMessageTexts["AMOUNT_LESS_THAN_FEE"] = "error_amount_less_than_fee";
    ErrorMessageTexts["LOAN_PAYMENT_MORE_THAN_CURRENT"] = "validation_amount_greater_than_loan";
    ErrorMessageTexts["LOAN_AMOUNT_LESS_THAN_MINIMUM"] = "staking_amount_less_than_minimum";
    ErrorMessageTexts["LOAN_AMOUNT_MORE_THAN_MAXIMUM"] = "error_loan_amount_more_than_maximum";
    ErrorMessageTexts["STAKING_TERM_NOT_FOUND"] = "error_staking_term_not_found";
    ErrorMessageTexts["NO_ACTIVE_STAKING_TYPES_FOUND"] = "error_no_active_staking_types_found";
    ErrorMessageTexts["STAKING_AMOUNT_LESS_THAN_MINIMUM"] = "error_staking_amount_less_than_minimum";
    ErrorMessageTexts["STAKING_AMOUNT_MORE_THAN_MAXIMUM"] = "staking_amount_more_than_maximum";
    ErrorMessageTexts["STAKING_NOT_FOUND"] = "common_not_found";
    ErrorMessageTexts["STAKING_AUTO_SUB_UNAVAILABLE"] = "staking_auto_sub_unavailable";
    ErrorMessageTexts["FEATURE_POLICY_ALREADY_EXISTS"] = "feature_already_exists";
    ErrorMessageTexts["EXCHANGE_PAIR_ALREADY_EXISTS"] = "error_exchange_pair_already_exists";
    ErrorMessageTexts["SWAP_NOT_FOUND"] = "error_swap_not_found";
    ErrorMessageTexts["ASSET_JURISDICTION_ALREADY_EXISTS"] = "error_asset_already_exists";
    ErrorMessageTexts["INVALID_REFUND_ADDRESS"] = "error_invalid_refund_address";
    ErrorMessageTexts["INVALID_DESTINATION_ADDRESS"] = "error_address_format_invalid";
    ErrorMessageTexts["MARGIN_ALREADY_EXISTS"] = "error_margin_already_exists";
    ErrorMessageTexts["WITHDRAWAL_FEE_ALREADY_EXISTS"] = "error_withdrawal_fee_already_exists";
    ErrorMessageTexts["NETWORK_ALREADY_EXISTS"] = "error_network_already_exists";
    ErrorMessageTexts["ASSET_NETWORK_ALREADY_EXISTS"] = "error_asset_network_already_exists";
    ErrorMessageTexts["USER_WITH_EMAIL_ALREADY_EXISTS"] = "error_user_is_already_registered";
    ErrorMessageTexts["BONUS_BALANCE_NOT_FOUND"] = "error_referral_bonus_balance_not_found";
    ErrorMessageTexts["REFERRER_IS_NOT_VERIFIED"] = "error_referrer_not_verified";
})(ErrorMessageTexts || (ErrorMessageTexts = {}));
//# sourceMappingURL=errorMessage.js.map